interface BscIconProps {
  className?: string
  size?: number
  colored?: boolean
}

export const BscIcon: React.FC<BscIconProps> = ({
  className,
  size = 24,
  colored = false,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.83 9.88L12 5.71L16.17 9.88L18.59 7.46L12 0.87L5.41 7.46L7.83 9.88ZM3.41 9.59L0.99 12.01L3.41 14.43L5.83 12.01L3.41 9.59ZM7.83 14.13L12 18.3L16.17 14.13L18.59 16.54L12 23.14L5.41 16.55L5.4 16.54L7.83 14.13ZM20.59 9.59L18.17 12.01L20.59 14.43L23.01 12.01L20.59 9.59ZM14.45 12L12 9.54L10.19 11.35L9.98 11.56L9.55 11.99L9.54 12L9.55 12.01L12 14.47L14.45 12.01L14.46 12L14.45 12Z"
        fill={colored ? '#F0B90B' : 'currentColor'}
      />
    </svg>
  )
}
